/*
 * Softchews Landing Page — shared behaviour
 * Accordions (ingredients + FAQ), hero thumbnail switcher, package card selection.
 */
(function () {
  'use strict';

  function toggleAccordionItem(item, group) {
    var isOpen = item.classList.contains('is-open');

    if (group) {
      group.querySelectorAll('.is-open').forEach(function (openItem) {
        if (openItem !== item) {
          openItem.classList.remove('is-open');
          var header = openItem.querySelector('[aria-expanded]');
          if (header) header.setAttribute('aria-expanded', 'false');
        }
      });
    }

    item.classList.toggle('is-open', !isOpen);
    var toggledHeader = item.querySelector('[aria-expanded]');
    if (toggledHeader) toggledHeader.setAttribute('aria-expanded', String(!isOpen));
  }

  function initAccordions(selector, itemSelector) {
    document.querySelectorAll(selector).forEach(function (group) {
      group.querySelectorAll(itemSelector).forEach(function (item) {
        var header = item.querySelector('.sfl_accordion_header, .sfl_faq_item_header');
        if (!header) return;
        header.addEventListener('click', function () {
          toggleAccordionItem(item, group);
        });
      });
    });
  }

  function initHeroGallery() {
    document.querySelectorAll('.sfl_hero').forEach(function (hero) {
      var mainImage = hero.querySelector('.sfl_hero_main_image img');
      var thumbs = hero.querySelectorAll('.sfl_hero_thumb');
      if (!mainImage || !thumbs.length) return;

      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var fullSrc = thumb.getAttribute('data-full-src');
          if (!fullSrc) return;
          mainImage.setAttribute('src', fullSrc);
          thumbs.forEach(function (t) {
            t.classList.remove('is-active');
          });
          thumb.classList.add('is-active');
        });
      });
    });
  }

  function initPackageSelector() {
    document.querySelectorAll('.sfl_packages_grid').forEach(function (grid) {
      var cards = grid.querySelectorAll('.sfl_package_card');
      cards.forEach(function (card) {
        card.addEventListener('click', function (e) {
          if (e.target.closest('a, button')) return;
          cards.forEach(function (c) {
            c.classList.remove('is-featured');
          });
          card.classList.add('is-featured');
        });
      });
    });
  }

  function initAddToCart() {
    document.querySelectorAll('.sfl_add_to_cart').forEach(function (button) {
      button.addEventListener('click', function () {
        var variantId = button.getAttribute('data-variant-id');
        var sellingPlanId = button.getAttribute('data-selling-plan-id');
        var quantity = parseInt(button.getAttribute('data-quantity'), 10) || 1;

        if (!variantId) {
          console.error('Softchews landing: missing data-variant-id on add to cart button.');
          return;
        }

        button.classList.add('is-loading');

        var items = [];
        if (sellingPlanId) {
          items.push({ id: variantId, quantity: quantity, selling_plan: sellingPlanId });
        } else {
          items.push({ id: variantId, quantity: quantity });
        }

        fetch('/cart/clear.js', { method: 'POST' })
          .then(function () {
            return fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ items: items })
            });
          })
          .then(function (response) {
            if (!response.ok) throw new Error('Error adding item to the cart.');
            window.location.href = '/checkout';
          })
          .catch(function () {
            alert('Error adding item to the cart.');
            button.classList.remove('is-loading');
          });
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAccordions('.sfl_ingredients_content', '.sfl_accordion_item');
    initAccordions('.sfl_faq_list', '.sfl_faq_item');
    initHeroGallery();
    initPackageSelector();
    initAddToCart();
  });
})();
